import { useEffect, useState } from 'react';
import axios from 'axios';
import QRCode from 'qrcode';
import { toast } from 'sonner';
import { Copy, Download, ImageIcon, Link2, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Başlık + QR + açıklamadan oluşan paylaşılabilir kart görseli
const buildCard = async (url, no, company) => {
  const qr = await QRCode.toDataURL(url, { width: 560, margin: 1, errorCorrectionLevel: 'M' });
  const img = await new Promise((res) => { const i = new Image(); i.onload = () => res(i); i.src = qr; });
  const c = document.createElement('canvas');
  c.width = 640; c.height = 820;
  const g = c.getContext('2d');
  g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
  g.fillStyle = '#0f172a'; g.fillRect(0, 0, c.width, 120);
  g.fillStyle = '#ffffff'; g.font = 'bold 34px sans-serif'; g.fillText('ÇALIŞMA İZNİ', 40, 62);
  g.font = '22px sans-serif'; g.fillStyle = '#cbd5e1'; g.fillText(`Talep #${no}${company ? `  ·  ${company}` : ''}`.slice(0, 48), 40, 98);
  g.drawImage(img, 40, 150, 560, 560);
  g.fillStyle = '#166534'; g.font = 'bold 22px sans-serif'; g.fillText('Güvenlik girişinde okutunuz', 40, 750);
  g.fillStyle = '#64748b'; g.font = '18px sans-serif'; g.fillText('Telefon kamerasıyla okutunca iznin geçerliliği görünür.', 40, 785);
  return c;
};

export const PermitQrDialog = ({ permit, companyName, onClose }) => {
  const [url, setUrl] = useState('');
  const [card, setCard] = useState(null);

  useEffect(() => {
    if (!permit) return;
    setUrl(''); setCard(null);
    axios.get(`${API}/work-permits/${permit.id}/verify-link`)
      .then(async (res) => { setUrl(res.data.url); setCard(await buildCard(res.data.url, permit.request_number, companyName)); })
      .catch(err => { toast.error(err.response?.data?.detail || 'QR kod oluşturulamadı'); onClose(); });
  }, [permit]);

  const download = () => {
    const a = document.createElement('a');
    a.href = card.toDataURL('image/png');
    a.download = `calisma_izni_${permit.request_number}_qr.png`;
    a.click();
  };
  const copyImage = () => card.toBlob(async (blob) => {
    try { await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]); toast.success('QR görseli kopyalandı; WhatsApp/e-postaya yapıştırabilirsiniz'); } catch { toast.error('Tarayıcınız görsel kopyalamayı desteklemiyor; "Resmi İndir" kullanın'); }
  });
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(url); toast.success('Doğrulama bağlantısı kopyalandı'); } catch { toast.error('Bağlantı kopyalanamadı'); }
  };

  return (
    <Dialog open={!!permit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="permit-qr-dialog">
        <DialogHeader>
          <DialogTitle>Onay QR Kodu – Talep #{permit?.request_number}</DialogTitle>
          <DialogDescription>Güvenlik girişte bu QR kodu telefon kamerasıyla okutur; iznin geçerli olup olmadığı anında görünür. Görseli kaydedip ekibinize gönderebilirsiniz.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center rounded-xl border bg-slate-50 p-3">
          {card ? <img src={card.toDataURL('image/png')} alt="QR kod" className="w-64" data-testid="permit-qr-image" /> : <Loader2 className="my-24 h-8 w-8 animate-spin text-slate-400" />}
        </div>
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
          <Button onClick={download} disabled={!card} data-testid="permit-qr-download"><Download className="mr-1.5 h-4 w-4" />Resmi İndir</Button>
          <Button variant="outline" onClick={copyImage} disabled={!card} className="hover:bg-slate-100 hover:text-slate-900" data-testid="permit-qr-copy-image"><ImageIcon className="mr-1.5 h-4 w-4" />Resmi Kopyala</Button>
          <Button variant="outline" onClick={copyLink} disabled={!url} className="hover:bg-slate-100 hover:text-slate-900" data-testid="permit-qr-copy-link"><Link2 className="mr-1.5 h-4 w-4" />Linki Kopyala</Button>
        </div>
        <p className="flex items-center gap-1 text-[11px] text-slate-400"><Copy className="h-3 w-3" />Bağlantıya sahip herkes yalnızca izin durumunu ve maskeli personel bilgisini görebilir.</p>
      </DialogContent>
    </Dialog>
  );
};
